export const FirebaseConfig = {
	"projectId": "tamex-f84bd",
	"appId": "1:1071510583729:web:01dab3e79e56055e572590",
	"databaseURL": "https://tamex-f84bd-default-rtdb.firebaseio.com",
	"storageBucket": "tamex-f84bd.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyCXx_gPHb34pfzXRlFTYGeMmwTjAytlJhg",
	"authDomain": "tamex-f84bd.firebaseapp.com",
	"messagingSenderId": "1071510583729"
};